import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Description`}</h3>
    <p>{`To resolve packages by name and version, npm talks to a registry website
that implements the CommonJS Package Registry specification for reading
package info.`}</p>
    <p>{`npm is configured to use the `}<strong parentName="p">{`npm public registry`}</strong>{` at
`}<a parentName="p" {...{
        "href": "https://registry.npmjs.org"
      }}>{`https://registry.npmjs.org`}</a>{` by default. Use of the npm public registry is
subject to terms of use available at `}<a parentName="p" {...{
        "href": "https://docs.npmjs.com/policies/terms"
      }}>{`https://docs.npmjs.com/policies/terms`}</a>{`.`}</p>
    <p>{`You can configure npm to use any compatible registry you like, and even run
your own registry. Use of someone else's registry may be governed by their
terms of use.`}</p>
    <p>{`npm's package registry implementation supports several
write APIs as well, to allow for publishing packages and managing user
account information.`}</p>
    <p>{`The npm public registry is powered by a CouchDB database,
of which there is a public mirror at `}<a parentName="p" {...{
        "href": "https://skimdb.npmjs.com/registry"
      }}>{`https://skimdb.npmjs.com/registry`}</a>{`.`}</p>
    <p>{`The registry URL used is determined by the scope of the package (see
`}<a parentName="p" {...{
        "href": "/cli/v8/using-npm/scope"
      }}><inlineCode parentName="a">{`scope`}</inlineCode></a>{`. If no scope is specified, the default registry is used, which is
supplied by the `}<inlineCode parentName="p">{`registry`}</inlineCode>{` config parameter.  See `}<a parentName="p" {...{
        "href": "/cli/v8/commands/npm-config"
      }}><inlineCode parentName="a">{`npm config`}</inlineCode></a>{`,
`}<a parentName="p" {...{
        "href": "/cli/v8/configuring-npm/npmrc"
      }}><inlineCode parentName="a">{`npmrc`}</inlineCode></a>{`, and `}<a parentName="p" {...{
        "href": "/cli/v8/using-npm/config"
      }}><inlineCode parentName="a">{`config`}</inlineCode></a>{` for more on managing npm's configuration.`}</p>
    <p>{`When the default registry is used in a package-lock or shrinkwrap is has the
special meaning of "the currently configured registry". If you create a lock
file while using the default registry you can switch to another registry and
npm will install packages from the new registry, but if you create a lock
file while using a custom registry packages will be installed from that
registry even after you change to another registry.`}</p>
    <h3>{`Does npm send any information about me back to the registry?`}</h3>
    <p>{`Yes.`}</p>
    <p>{`When making requests of the registry npm adds two headers with information
about your environment:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Npm-Scope`}</inlineCode>{` – If your project is scoped, this header will contain its
scope. In the future npm hopes to build registry features that use this
information to allow you to customize your experience for your
organization.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`Npm-In-CI`}</inlineCode>{` – Set to "true" if npm believes this install is running in a
continuous integration environment, "false" otherwise. This is detected by
looking for the following environment variables: `}<inlineCode parentName="li">{`CI`}</inlineCode>{`, `}<inlineCode parentName="li">{`TDDIUM`}</inlineCode>{`,
`}<inlineCode parentName="li">{`JENKINS_URL`}</inlineCode>{`, `}<inlineCode parentName="li">{`bamboo.buildKey`}</inlineCode>{`. If you'd like to learn more you may find
the `}<a parentName="li" {...{
          "href": "https://github.com/npm/npm-registry-client/pull/129"
        }}>{`original PR`}</a>{`
interesting.
This is used to gather better metrics on how npm is used by humans, versus
build farms.`}</li>
    </ul>
    <p>{`The npm registry does not try to correlate the information in these headers
with any authenticated accounts that may be used in the same requests.`}</p>
    <h3>{`How can I prevent my package from being published in the official registry?`}</h3>
    <p>{`Set `}<inlineCode parentName="p">{`"private": true`}</inlineCode>{` in your `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` to prevent it from being
published at all, or
`}<inlineCode parentName="p">{`"publishConfig":{"registry":"http://my-internal-registry.local"}`}</inlineCode>{`
to force it to be published only to your internal/private registry.`}</p>
    <p>{`See `}<a parentName="p" {...{
        "href": "/cli/v8/configuring-npm/package-json"
      }}><inlineCode parentName="a">{`package.json`}</inlineCode></a>{` for more info on what goes in the package.json file.`}</p>
    <h3>{`Where can I find my own, & other's, published packages?`}</h3>
    <p><a parentName="p" {...{
        "href": "https://www.npmjs.com/"
      }}>{`https://www.npmjs.com/`}</a></p>
    <h3>{`See also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-config"
        }}>{`npm config`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/config"
        }}>{`config`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/npmrc"
        }}>{`npmrc`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/developers"
        }}>{`npm developers`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      